import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Docs from "./pages/Docs";
import Wallet from "./pages/Wallet";
import PrivicyPolicy from "./pages/PrivicyPolicy";

function AppContent() {
  const location = useLocation();
  const hideFooter = location.pathname === '/privicy-policy';

  return (
    <div style={{ overflowX: 'hidden' }} className="flex flex-col min-h-screen bg-white dark:bg-[#111111] transition-colors duration-300">
      <Navbar />

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/privicy-policy" element={<PrivicyPolicy />} />
        </Routes>
      </main>

      {!hideFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
